import { Dispatch } from 'redux';
import { Moment } from 'moment';

export const SET_DATE_FROM = 'AFISHA_SET_DATE_FROM';
export const SET_DATE_TO = 'AFISHA_SET_DATE_TO';
export const SET_DATE_FORMAT_TEXT = 'AFISHA_SET_DATE_FORMAT_TEXT';

export const setDateFromAction = (dateFrom: Moment) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_DATE_FROM,
    dateFrom
});

export const setDateToAction = (dateTo: Moment | null) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_DATE_TO,
    dateTo
});

export const setDateFormatTextAction = (dateFormatText: string) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_DATE_FORMAT_TEXT,
    dateFormatText
});



// WEBPACK FOOTER //
// ./src/actions/Afisha/date.ts